import React from "react"

const Placeholder = () => {
  return <div>There are no posts published yet.</div>
}

export default Placeholder
